import {
  ISubscriptionAttachment,
  ISubscriptionItemCurrentUserSubscription,
} from "web/types/Subscription";
import { Nullable } from "web/types/Utils";

interface IGroupBenefitsSummaryCurrentUser {
  benefitGroupAttachments: ISubscriptionAttachment[];
  groupName: string;
  groupPhotoURL: Nullable<string>;
  id: string;
  items: ISubscriptionItemCurrentUserSubscription[];
  benefitGroupType: number | undefined;
}

export default function prepareSubscriptionGroupsSummaryForCurrentUser(
  benefits: ISubscriptionItemCurrentUserSubscription[]
): IGroupBenefitsSummaryCurrentUser[] {
  const groups: IGroupBenefitsSummaryCurrentUser[] = [];

  benefits.forEach((item) => {
    const {
      benefit: {
        benefitGroup: {
          id: groupId,
          benefitGroupAttachments,
          groupPhoto,
          groupType,
        },
      },
      groupName,
    } = item;

    const groupPhotoURL = groupPhoto?.contentUrl ?? null;

    const existingGroup = groups.find((group) => group.id === groupId);

    if (existingGroup) {
      existingGroup.items.push(item);
    } else {
      groups.push({
        id: groupId,
        groupName,
        groupPhotoURL,
        benefitGroupAttachments,
        benefitGroupType: groupType,
        items: [item],
      });
    }
  });

  return groups;
}
